import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { DirectivesModule } from "src/app/directives/directives.module";
import { ApgCoverCalculatorModule } from "../apg-cover-calculator/apg-cover-calculator.module";
import { QuestionsModule } from "../questions/questions.module";
import { SharedModule } from "../shared/shared.module";
import { ApgBarGraphComponent } from "./apg-bar-graph/apg-bar-graph.component";
import { ApgBeatYourBrokerCompleteComponent } from "./apg-beat-your-broker-complete/apg-beat-your-broker-complete.component";
import { BeatYourBrokerHelper } from "./apg-beat-your-broker-helper";
import { ApgBeatYourBrokerPageComponent } from "./apg-beat-your-broker-page/apg-beat-your-broker-page.component";
import { ApgBeatYourBrokerResultComponent } from "./apg-beat-your-broker-result/apg-beat-your-broker-result.component";
import { ComparisonTableComponent } from "./apg-beat-your-broker-result/comparison-table/comparison-table.component";
import { ApgContactRequestComponent } from "./apg-beat-your-broker-result/contact-request/contact-request.component";
import { ApgBeatYourBrokerRoutingModule } from "./apg-beat-your-broker-routing.module";
import { ApgBeatYourBrokerComponent } from "./apg-beat-your-broker.component";
import { ApgPieChartComponent } from "./apg-pie-chart/apg-pie-chart.component";
import { BeatYourBrokerRoute } from "./beat-your-broker-route/beat-your-broker.route";
import { CoverCalculatorRoute } from "./cover-calculator-route/cover-calculator.route";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DirectivesModule,
    NgxSliderModule,
    CurrencyMaskModule,
    SharedModule,
    QuestionsModule,
    ApgBeatYourBrokerRoutingModule,
    ApgCoverCalculatorModule,
    NgxChartsModule
  ],
  providers: [
    CurrencyPipe,
    BeatYourBrokerHelper
  ],
  exports: [
    ApgBeatYourBrokerComponent
  ],
  declarations: [
    ApgBeatYourBrokerComponent,
    ApgContactRequestComponent,
    ApgBeatYourBrokerPageComponent,
    ApgBeatYourBrokerResultComponent,
    ApgPieChartComponent,
    ApgBarGraphComponent,
    ComparisonTableComponent,
    ApgBeatYourBrokerCompleteComponent,

    BeatYourBrokerRoute,
    CoverCalculatorRoute
  ]
})
export class ApgBeatYourBrokerModule { }

